// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"24ec017a","257":"dc3b1659","361":"74fc3f1a","422":"1c335a28","511":"ceffbb0b","673":"907ffe62"}[chunkId] + ".chunk.js";
};